import React from 'react';
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Chip,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from 'react-i18next';
import { getLanguageByCode } from '../../constants';

/**
 * 개별 인기 영상 카드 컴포넌트
 * @param {object} video - 영상 정보
 * @param {function} onVideoClick - 영상 클릭 핸들러
 * @param {function} truncateTitle - 제목 자르기 함수
 * @returns {JSX.Element}
 */
const PopularVideoCard = ({ video, onVideoClick, truncateTitle }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid item xs={6} sm={4} md={3} key={video.videoId}>
      <Card 
        sx={{ 
          borderRadius: 2, 
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: theme.shadows[4]
          }
        }}
        onClick={() => onVideoClick(video.videoId)}
      >
        {/* 썸네일 */}
        <Box sx={{ position: 'relative' }}>
          <CardMedia
            component="img"
            height={isMobile ? 100 : 120}
            image={video.thumbnail}
            alt={video.title}
            sx={{
              objectFit: 'cover',
              backgroundColor: '#f5f5f5'
            }}
          />
          {/* 재생 아이콘 오버레이 */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              opacity: 0,
              transition: 'opacity 0.2s ease-in-out',
              '&:hover': {
                opacity: 1
              }
            }}
          >
            <PlayArrowIcon sx={{ color: 'white', fontSize: 40 }} />
          </Box>
        </Box>

        {/* 콘텐츠 */}
        <CardContent sx={{ p: 1.5, pb: '12px !important' }}>
          {/* 제목 */}
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: 500,
              lineHeight: 1.3,
              mb: 0.5,
              fontSize: isMobile ? '0.8rem' : '0.875rem',
              color: '#333'
            }}
          >
            {truncateTitle(video.title, isMobile ? 40 : 60)}
          </Typography>

          {/* 국기와 사용 횟수 */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
            <Box
              sx={{
                fontSize: '1.1em',
                lineHeight: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 20,
                height: 20
              }}
            >
              {getLanguageByCode(video.language || 'ko').flag}
            </Box>
            <Chip
              icon={<VisibilityIcon sx={{ fontSize: '14px !important' }} />}
              label={`${video.usageCount}${t('landing.analysisCount')}`}
              size="small"
              sx={{
                height: 20,
                fontSize: '0.7rem',
                bgcolor: '#f0f0f0',
                color: '#666',
                '& .MuiChip-icon': {
                  fontSize: '14px'
                }
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default PopularVideoCard; 